<template>
  <el-dialog
    :title="'查看箱信息'"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="handleCancel"
  >
    <div v-loading="loading" style="min-height: 100px;">
      <el-table :data="cartonList" style="width: 100%" border>
        <el-table-column prop="cartonIndex" align="center" label="箱序号" min-width="180"></el-table-column>
        <el-table-column prop="cartonNo" align="center" label="箱号" min-width="180"></el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CheckCartonList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal && this.orderId) {
          this.getCartonData();
        }
      }
    },
    dialogVisible: {
      handler(newVal) {
        this.$emit('update:visible', newVal);
      }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      cartonList: [],
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false;
    },
    getCartonData() {
      this.loading = true;
      let query = {
        orderId: '',
        page: this.currentPage,
        limit: this.pageSize,
        customerOrderNo:this.orderId,
      };
      this.$http.post('/toborder/wms/fulfillment/queryOrderCarton', query).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.cartonList = res.data.list;
          this.total = res.data.totalCount;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.msg);
      });
    },
    // 分页事件处理
    handleSizeChange(size) {
      this.pageSize = size;
      this.getCartonData();
    },
    handleCurrentChange(current) {
      this.currentPage = current;
      this.getCartonData();
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>